const initState = {
	isSending: false,
	error: null,
	excel_invite: [],
}

export default initState
